module.exports = __webpack_public_path__ + "img/Guest-Bathroom.a5cb6a49.png";